import { createAction, props } from '@ngrx/store';

export const addWorkspaceId = createAction(
  '[WorkSpace] Add Work Space Id',
  props<{ workspaceId: string }>(),
);

export const addWorkspaceTypeId = createAction(
  '[WorkSpace] Add Work Space Type Id',
  props<{ workspaceTypeId: string }>(),
);
export const addWorkspaceStudyId = createAction(
  '[WorkSpace] Add Work Space Study Id',
  props<{ workspaceStudyId: string }>(),
);

export const addWorkspaceQuestionnaireId = createAction(
  '[WorkSpace] Add Work Space Questionnaire Id',
  props<{ workspaceQuestionnaireId: string }>(),
);
